import { render, staticRenderFns } from "./laowu-project-audit.vue?vue&type=template&id=45f74058&scoped=true"
import script from "./laowu-project-audit.vue?vue&type=script&lang=js"
export * from "./laowu-project-audit.vue?vue&type=script&lang=js"
import style0 from "./laowu-project-audit.vue?vue&type=style&index=0&id=45f74058&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f74058",
  null
  
)

export default component.exports